import React from 'react';

interface ErrorStateProps {
  error: string;
  isMimicking: boolean;
  onRetry: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ error, isMimicking, onRetry }) => {
  return (
    <div
      className={`min-h-screen flex items-center justify-center bg-gray-50 ${
        isMimicking ? 'mt-[52px]' : ''
      }`}
    >
      <div className="text-center max-w-md mx-auto px-4">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6">
          <h2 className="text-lg font-semibold text-red-800 mb-2">Preview Error</h2>
          <p className="text-red-700 mb-4">{error}</p>
          <div className="space-y-3">
            <button onClick={onRetry} className="btn-primary">
              Try Again
            </button>
            <div className="text-sm text-gray-600">
              <p className="mb-2">
                <strong>Possible solutions:</strong>
              </p>
              <ul className="text-left space-y-1">
                <li>• Go back to the page editor and save the page again</li>
                <li>• Check if the page has any corrupted components</li>
                <li>• Try refreshing your browser and logging in again</li>
                <li>• Contact support if the problem persists</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
